// no-op for now
export const useDebugValue = <T>(
  _value: T,
  _format?: (value: T) => unknown,
): void => {};
